const PublicationModule = resolve =>
  require(['src/views/publication/PublicationModule'], resolve)
const PublicationPublishManage = resolve =>
  require(['src/views/publication/PublicationPublishManage'], resolve)
const BrandPublication = resolve =>
  require(['src/views/publication/BrandPublication'], resolve)
const Resource = resolve =>
  require(['src/views/resource/ResourceManage'], resolve)
const MagazineModule = resolve =>
  require(['src/views/magazine/MagazineModule.vue'], resolve)
const MagazineCreate = resolve =>
  require(['src/views/magazine/MagazineCreate.vue'], resolve)
const MagazineManage = resolve =>
  require(['src/views/magazine/MagazineManage.vue'], resolve)
const MagazineBasicManage = resolve =>
  require(['src/views/magazine/MagazineBasicManage.vue'], resolve)
const MagazineContentManage = resolve =>
  require(['src/views/magazine/MagazineContentManage.vue'], resolve)
const PublicationPageManage = resolve =>
  require(['src/views/page/PageManage'], resolve)
const PromotionPage = resolve =>
  require(['src/views/promotion/promotion'], resolve)
const ReportPage = resolve => require(['src/views/report/report'], resolve)
const PushModule = resolve =>
  require(['src/views/push/PushModule.vue'], resolve)
const TopicManage = resolve => require(['src/views/topic/TopicManage'], resolve)
const PushPage = resolve => require(['src/views/push/push.vue'], resolve)
const PushNewPage = resolve => require(['src/views/push/pushNew.vue'], resolve)
const SettingPage = resolve => require(['src/views/setting/Setting'], resolve)
const ThemePage = resolve => require(['src/views/theme/ThemePage.vue'], resolve)

const brandPublicationRouter = {
  path: '/brand/:publicationId',
  component: PublicationModule,
  children: [
    {
      name: 'Brand页面',
      path: '/brand/:publicationId/',
      component: PublicationPageManage,
    },
    {
      name: 'Brand素材库',
      path: '/brand/:publicationId/resource',
      component: Resource,
    },
    {
      name: 'Brand栏目',
      path: '/brand/:publicationId/column',
      component: BrandPublication,
    },
    {
      name: 'Brand社群',
      path: '/brand/:publicationId/topic',
      component: TopicManage,
    },
    {
      name: 'Brand创建栏目',
      path: '/brand/:publicationId/magazine/create',
      component: MagazineCreate,
    },
    {
      name: 'Brand发布',
      path: '/brand/:publicationId/publish',
      component: PublicationPublishManage,
    },
    {
      path: '/brand/:publicationId/magazine/:magazineId',
      component: MagazineModule,
      children: [
        {
          name: 'Brand文章',
          path: '/brand/:publicationId/magazine/:magazineId/',
          component: MagazineManage,
        },
        {
          name: 'Brand文章管理',
          path: '/brand/:publicationId/magazine/:magazineId/article',
          component: MagazineManage,
        },
        {
          name: 'Brand主编管理',
          path: '/brand/:publicationId/magazine/:magazineId/contributor',
          component: MagazineManage,
        },
        {
          name: 'Brand推广杂志',
          path: '/brand/:publicationId/magazine/:magazineId/promotion',
          component: MagazineManage,
        },
        {
          name: 'Brand配置杂志',
          path: '/brand/:publicationId/magazine/:magazineId/config',
          component: MagazineManage,
        },
        {
          name: 'Brand编辑杂志',
          path: '/brand/:publicationId/magazine/:magazineId/edit',
          component: MagazineBasicManage,
        },
        {
          name: 'Brand内容管理',
          path: '/brand/:publicationId/magazine/:magazineId/content',
          component: MagazineContentManage,
        },
      ],
    },
    {
      name: 'Brand主题',
      path: '/brand/:publicationId/theme',
      component: ThemePage,
    },
    {
      name: 'Brand分析',
      path: '/brand/:publicationId/report',
      component: ReportPage,
    },
    {
      name: 'Brand推广',
      path: '/brand/:publicationId/promotion',
      component: PromotionPage,
    },
    {
      name: 'Brand推送',
      path: '/brand/:publicationId/push',
      component: PushModule,
      children: [
        {
          name: 'BrandPush',
          path: '/brand/:publicationId/push/',
          component: PushPage,
        },
        {
          name: 'Brand新建',
          path: '/brand/:publicationId/push/new',
          component: PushNewPage,
        },
      ],
    },
    {
      name: 'Brand栏目设置',
      path: '/brand/:publicationId/setting',
      component: SettingPage,
    },
  ],
}

export default brandPublicationRouter
